import React from 'react';
import './crisis-resources.scss';
import Button from '../../components/Button';
import CrisisCard from '../../components/CrisisCard';
import { useNavigate } from 'react-router-dom';

// vague-hurting
const CrisisResource: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div className="crisis-resources">
            <h1 className="crisis-resources__title">Crisis Resources</h1>
            <h4 className="crisis-resources__subtitle">It's not uncommon to find ourselves entangled in certain thought patterns when facing depression. If you notice these thoughts becoming sharper or more persistent, seeking help is a brave and important step towards understanding and managing them.</h4>
            <CrisisCard />
            <h4 className="crisis-resources__subtitle">Should you decide to continue with us at The Anxiety Center, know that a range of treatments, including antidepressants, have proven to be highly beneficial for many facing serious depression. Together, we can find the right approach for you.</h4>
            <h4 className="crisis-resources__subtitle">Please keep in mind that initiating treatment with antidepressants may initially intensify suicidal thoughts in some individuals, particularly those under 24. It's imperative to maintain open lines of communication with your healthcare provider and to seek immediate assistance if your symptoms escalate.</h4>
            <Button type='primary' onPressed={() => { navigate('/result', { replace: true }); }}>
                {'I understand'}
            </Button>
        </div>
    );
}

export default CrisisResource;
